module.exports = "/fonts/fa-solid-900.woff?4bced7c4c0d61d4f988629bb8ae80b8b";